import { ProductDto } from '@core/services/dto';

export class ProductModel {
  label: string;
  value: number;
  active: boolean;
  type: {
    id: number;
    name: string;
  };
  productId?: number;

  constructor(dto: ProductDto) {
    this.label = dto.name;
    this.value = dto.id;
    this.active = dto.active;
    this.type = dto.type;
    this.productId = dto.productId;
  }
}
